import {UserTaskTypeConstants} from "finhelper";

import {Body} from "#app/components/Text/Typography";

import {SelectItem} from "./styles";
import {useTaskTypesIcons} from "#app/pages/Relations/Contacts/hooks/useTaskTypesIcons";

const SelectType = ({ typeId, setType }) =>
{
  const { iconsList, currentIcon, setIcon } = useTaskTypesIcons(typeId);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', margin: '10px 0' }}>
      {iconsList.map(type => (
        <SelectItem
          key={type.id}
          className={typeId === type.id ? 'active' : ''}
          onClick={() => setType(type.id)}
        >
          {type.icon}
          <Body>{type.text}</Body>
        </SelectItem>
      ))}
    </div>
  );
};

export default SelectType;
